/*
 * Deskon - collection banner: keeps the description's box narrower than the collection name's.
 *
 * ------------------------------------------------------------------------------------------------
 * WHY A SCRIPT AT ALL. The two are siblings, each sized on its own: the title is fit-content on its
 * text, the description wraps at the theme's max-width. CSS has no way to express "as wide as that
 * OTHER element" - there is no sibling reference, and a container query answers about an ancestor,
 * not a neighbour. So the width has to be measured.
 *
 * THAT FIRST PARAGRAPH IS THE FILE'S ORIGINAL CLAIM AND IT IS NOT TRUE OF WHAT IS MEASURED BELOW.
 * getBoundingClientRect() on the title returns its BORDER BOX, and .text-block is a block element:
 * that box is the full width of the centred column at every size, whatever the type is set at and
 * however short the collection's name. So this script does not relate the description to the TITLE
 * at all - it relates it to the COLUMN, exactly as a percentage would.
 *
 * TWO THINGS FOLLOW, AND BOTH HAVE ALREADY CAUGHT SOMEONE OUT:
 *
 *   - Making the title bigger has never widened the description. A slope change in
 *     assets/deskon-collection-banner.css was once made for that reason and could not have worked.
 *   - "Not wider than the title" is not enforced. On Portable Lamps the title's text nearly fills
 *     the column and the rule holds by accident; on Gallery it does not hold at all.
 *
 * MAKING IT REAL WOULD MEAN MEASURING THE TEXT - a Range over the title's contents, widest client
 * rect - and accepting that a short name leaves the paragraph a narrow ribbon. That trade has not
 * been made. Until it is, read RATIO as a fraction of the column.
 * ------------------------------------------------------------------------------------------------
 *
 * WHAT IT CANNOT DO IS THE POINT. It writes ONE custom property, and the stylesheet uses it only
 * inside a min() that feeds max-width. A max-width can make a box narrower and nothing else - so
 * whatever number this script produces, right or wrong, it cannot widen the page, cannot move a
 * neighbour, and cannot overflow anything. If it never runs, the stylesheet's own fallback applies
 * and the banner still looks deliberate. That is the whole reason this is allowed to be a script.
 *
 * NO FEEDBACK LOOP. Narrowing the description cannot change the title's width: the title is sized
 * inside a fixed-width centred column. So measure-then-write settles in one pass, and re-running it
 * is idempotent.
 *
 * IT RUNS AGAIN AFTER THE WEBFONT LOADS. The first pass measures the fallback face, which is not
 * the one the title will be set in - the same reason deskon-hero-fit.js listens to fonts.ready.
 * Harmless today, since the box does not depend on the face; kept because it will matter the day
 * the measurement moves to the text.
 */

(function () {
  'use strict';

  var TITLE = "main[data-template^='collection'] .text-block[class*='header_title']";
  var SUBTITLE = "main[data-template^='collection'] .text-block[class*='header_subtitle']";
  var PROPERTY = '--dk-banner-sub-max';

  /* 0.88 -> 0.96, RAISED SO THAT IT STOPS BINDING. The width the visitor actually gets is
     min(this ratio, the percentage in assets/deskon-collection-banner.css) x the column. At 0.88
     against a 94% cap this number was the smaller of the two and quietly held the description at
     0.88 of the column - so moving the percentage alone would have bought two per cent instead of
     nine. THE TWO NUMBERS HAVE TO MOVE TOGETHER; the percentage is the dial, this is the ceiling
     that has to stay above it. */
  var RATIO = 0.96;

  function fit() {
    var title = document.querySelector(TITLE);
    var subtitle = document.querySelector(SUBTITLE);
    if (!title || !subtitle) return;

    var width = title.getBoundingClientRect().width;
    if (!(width > 0)) return;

    subtitle.style.setProperty(PROPERTY, Math.round(width * RATIO) + 'px');
  }

  var queued = false;

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule);
  }
})();
